import { isRequiredText, isRequiredWithObjEqual, strMax } from '../../utils';
export default {
    organizationId: [isRequiredText('企業名を選択してください')],
    organizationOther: (otherId) => [
        isRequiredWithObjEqual('その他を入力してください', 'organizationId', (otherId || '').toString()),
        strMax(50, 'その他は50文字以内で入力してください'),
    ],
};
